import React, { useEffect } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogIn, BookOpen } from 'lucide-react';

export const Login = () => {
  const { login, handleCallback, isAuthenticated, error } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      console.error('OAuth error:', error);
      return;
    }

    if (code && state) {
      handleCallback(code, state);
    }
  }, [searchParams, handleCallback]);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-discord-darker">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          <div className="flex justify-center">
            <BookOpen className="w-16 h-16 text-discord-blurple" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-white">
            Welcome to Storybook
          </h2>
          <p className="mt-2 text-discord-light">
            Manage your Discord bot characters and settings
          </p>
        </div>

        <div className="discord-card">
          <h3 className="text-lg font-semibold text-white mb-4">
            Login with Discord
          </h3>
          
          <p className="text-discord-light mb-6">
            Connect your Discord account to access your Storybook dashboard and manage your characters.
          </p>

          <button
            onClick={() => {
              console.log('Button clicked!');
              login();
            }}
            className="w-full discord-button flex items-center justify-center space-x-2"
          >
            <LogIn className="w-5 h-5" />
            <span>Login with Discord</span>
          </button>

          {error && (
            <div className="mt-4 p-3 bg-discord-red/20 border border-discord-red/50 rounded-lg">
              <p className="text-discord-red text-sm">
                Login failed: {error}
              </p>
            </div>
          )}

          <div className="mt-6 text-xs text-discord-light/60">
            <p>By logging in, you agree to let Storybook access your Discord account information.</p>
            <p className="mt-2">We only request basic permissions to identify you and manage your characters.</p>
          </div>
        </div>

        <div className="text-center">
          <p className="text-discord-light/60 text-sm">
            Storybook Discord Bot Dashboard
          </p>
        </div>
      </div>
    </div>
  );
};
